var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.583 2.82c0-1.16-.932-2.1-2.083-2.1-1.15 0-2.083.94-2.083 2.1v2.23c-2.451.306-4.696 1.147-6.477 2.404C9.67 9.053 8 11.467 8 14.37c0 2.903 1.67 5.317 3.94 6.918 1.78 1.257 4.026 2.097 6.477 2.404v10.456c-1.622-.272-3.027-.852-4.088-1.6-1.5-1.06-2.162-2.322-2.162-3.478 0-1.16-.933-2.1-2.084-2.1-1.15 0-2.083.94-2.083 2.1 0 2.903 1.67 5.317 3.94 6.918 1.78 1.257 4.026 2.097 6.477 2.404v2.228c0 1.16.932 2.1 2.083 2.1 1.15 0 2.083-.94 2.083-2.1v-2.228c2.451-.307 4.696-1.147 6.477-2.404C31.33 34.387 33 31.973 33 29.07c0-2.903-1.67-5.316-3.94-6.917-1.78-1.257-4.026-2.098-6.477-2.404V9.292c1.622.273 3.027.853 4.088 1.601 1.5 1.06 2.162 2.32 2.162 3.477 0 1.16.933 2.1 2.084 2.1 1.15 0 2.083-.94 2.083-2.1 0-2.903-1.67-5.316-3.94-6.917-1.78-1.257-4.026-2.098-6.477-2.404V2.82Zm-4.166 6.472c-1.622.273-3.027.853-4.088 1.601-1.5 1.06-2.162 2.32-2.162 3.477s.661 2.418 2.162 3.477c1.061.749 2.466 1.329 4.088 1.601V9.292Zm4.166 14.7v10.156c1.622-.272 3.027-.852 4.088-1.6 1.5-1.06 2.162-2.322 2.162-3.478 0-1.156-.661-2.418-2.162-3.477-1.061-.748-2.466-1.328-4.088-1.601Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.c60f4367175d7d8994a7297f86c08e36.svg";
export { ForwardRef as ReactComponent };